import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core/model/keyvalue.model';
import { Observable } from 'rxjs';
import { logRequest } from '../shared/http-utils';
import { BankAccountSearch, IBankAccount } from './../bank-accounts/bank-account.model';
import { SchoolService } from './school.service';

@Injectable({
    providedIn: 'root',
})
export class BankAccountService {
    baseUrl = '/school-service/api/bank-accounts';

    constructor(
        private http: HttpClient,
        private schoolService: SchoolService
    ) {}

    getAllActiveBankAccounts(): Observable<HttpResponse<KeyValueDTO[]>> {
        const id = this.schoolService.getActiveSchool().id;
        return this.http.get<KeyValueDTO[]>(`${this.baseUrl}/school/${id}`, { observe: 'response' });
    }

    deleteBankAccount(id: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/${id}`, { observe: 'response', headers: logRequest() });
    }

    createBankAccount(bankAccount: IBankAccount): Observable<HttpResponse<IBankAccount>> {
        return this.http.post<IBankAccount>(this.baseUrl, bankAccount, { observe: 'response', headers: logRequest() });
    }

    updateBankAccount(bankAccount: IBankAccount): Observable<HttpResponse<IBankAccount>> {
        return this.http.put<IBankAccount>(this.baseUrl, bankAccount, { observe: 'response', headers: logRequest() });
    }

    searchBankAccounts(search: BankAccountSearch): Observable<HttpResponse<IBankAccount[]>> {
        search.schoolId = this.schoolService.getActiveSchool().id;
        return this.http.post<IBankAccount[]>(`${this.baseUrl}/search`, search, { observe: 'response' });
    }
}
